import * as React from 'react';
import { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
var slidesPerView = {
    desktop: 4,
    mobile: 2
};
export function LogotypeCarousel(props) {
    var imgs = props.logotypeUrls;
    var _a = useState(0), activeIndex = _a[0], updateIndex = _a[1];
    if (!imgs) {
        return null;
    }
    useEffect(function () {
        return;
    }, [activeIndex]);
    var breakpoints = {
        0: {
            slidesPerView: slidesPerView.mobile
        },
        800: {
            slidesPerView: slidesPerView.desktop
        }
    };
    var paginationOptions = {
        clickable: true
    };
    var slides = imgs.filter(function (img) { return img; });
    return (React.createElement(React.Fragment, null,
        React.createElement(Swiper, { spaceBetween: 20, breakpoints: breakpoints, pagination: paginationOptions, modules: [Pagination] }, slides.map(function (img, index) {
            return React.createElement(SwiperSlide, { key: "slide-no-".concat(index + 1) },
                React.createElement(Slide, { img: img, itemIndex: index, activeIndex: activeIndex }));
        }))));
}
function Slide(props) {
    var img = props.img;
    if (!img) {
        return null;
    }
    return (React.createElement("div", { className: 'barkfors-logotype-item', style: { backgroundImage: "url(".concat(img, "?width=200)") } }));
}
